import { Component, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CHAGEBEE_PLANS } from '../../../../app/utils/const';
import { OrganizationService } from 'src/app/data/service/organization.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Position, Type } from 'src/app/utils/const';
import { AsideExtenderService } from 'src/app/data/service/aside-extender.service';
import { ShareService } from 'src/app/data/service/share.service';
import { AppAuthGuardService } from 'src/app/data/service/app-auth-guard.service';
import { Organization } from 'src/app/data/model/organization';
import { LoaderService } from 'src/app/layouts/loader-chargebee/loader.service';
import { createPopup, createWidget } from '@typeform/embed';

@Component({
  selector: 'app-upgrade-plan-dks',
  templateUrl: './upgrade-plan-dks.component.html',
  styleUrls: ['./upgrade-plan-dks.component.scss'],
})
export class UpgradePlanDksComponent implements OnInit {
  subscription_type: any = {
    annual: {
      enabled: true,
      title: 'Annuel',
      value: 'yearly',
      starter: 'Soutenu par',
      pro: '1,600,000',
      enterprise: 'Sur mesure',
      price_unit: 'XOF/mois',
    },
    monthly: {
      enabled: false,
      title: 'Mensuel',
      value: 'monthly',
      starter: 'Soutenu par',
      pro: '2,000,000',
      enterprise: 'Sur mesure',
      price_unit: 'XOF/mois',
    },
  };

  features_1: any = [
    {
      is_starter: true,
      title: '4 vCPU',
      description:
        "Si vous êtes une startup soutenue par un VC, une startup soutenue par le gouvernement ou une startup de l'un de nos autres partenaires, cliquez sur ce bouton et donnez-nous votre code d'organisation.",
      icon: '../../../assets/icons/upgrade/icon1.svg',
    },
  ];
  features_2: any = [
    {
      title: '24 vCPU',
      description: 'Performance professionnelle',
      icon: '../../../assets/icons/upgrade/icon1.svg',
    },
    {
      title: '48 GB RAM',
      description: 'Mémoire professionnelle',
      icon: '../../../assets/icons/upgrade/icon2.svg',
    },
    {
      title: '1000 GB SSD',
      description: 'Stockage enterprise',
      icon: '../../../assets/icons/upgrade/icon3.svg',
    },
    {
      title: '1000 GB Object',
      description: 'Stockage évolutif',
      icon: '../../../assets/icons/upgrade/icon4.svg',
    },
    {
      title: '3000 GB Egress',
      description: 'Bande passante illimitée',
      icon: '../../../assets/icons/upgrade/icon5.svg',
    },
  ];
  features_3: any = [
    {
      title: 'Cluster K8s dédié',
      description: 'Control plane managé',
      icon: '../../../assets/icons/upgrade/icon6.svg',
    },
    {
      title: 'SSO Enterprise',
      description: 'AzureAD, Google WS, LDAP',
      icon: '../../../assets/icons/upgrade/icon7.svg',
    },
    {
      title: 'CI/CD & API illimités',
      description: 'Sans restriction',
      icon: '../../../assets/icons/upgrade/icon8.svg',
    },
    {
      title: 'Export SIEM',
      description: 'Logs, métriques, traces',
      icon: '../../../assets/icons/upgrade/icon9.svg',
    },
    {
      title: 'Support 24×7',
      description: 'Support premium inclus',
      icon: '../../../assets/icons/upgrade/icon10.svg',
    },
  ];

  plans: any = [
    {
      title: 'Starter',
      price: 'Soutenu par',
      price_unit: null,
      current: false,
      btn_action: {
        title: 'Code partenaire',
        icon: '../../../assets/icons/upgrade/icon11.svg',
      },
      popular: {
        enabled: false,
        title: 'Populaire',
      },
      features: this.features_1,
      typeform: '01K2KVJEP83CMTBHKSZ626T716',
      show_typeform: false,
    },
    {
      title: 'Pro',
      price: '2,000,000',
      price_unit: 'XOF/mois',
      current: false,
      btn_action: {
        title: "Commencer l'essai",
      },
      popular: {
        enabled: true,
        title: 'Populaire',
      },
      features: this.features_2,
      typeform: '',
      show_typeform: false,
    },
    {
      title: 'Enterprise',
      price: 'Sur mesure',
      price_unit: null,
      current: false,
      btn_action: {
        title: "Contacter l'équipe",
      },
      popular: {
        enabled: false,
        title: 'Populaire',
      },
      features: this.features_3,
      typeform: '01K2KVDJP87J81Z5WYKBERQQ8G',
      show_typeform: false,
    },
  ];

  chargebeePlans = CHAGEBEE_PLANS;
  plan_selected: any = this.subscription_type.annual;
  upgradeForm: FormGroup;
  currentOrganization: any;
  loading: boolean = false;
  planName: string = '';

  constructor(
    public modalRef: BsModalRef,
    public modalRef2: BsModalRef,
    public auth: AppAuthGuardService,
    private modalService: BsModalService,
    public shareService: ShareService,
    private loaderService: LoaderService,
    private asideExtenderService: AsideExtenderService,
    private organizationService: OrganizationService
  ) {}

  ngOnInit(): void {
    this.currentOrganization = this.shareService.organizationSelected;
    this.changeSubscriptionType(this.plan_selected.value);
  }

  changeSubscriptionType(type: string) {
    if (type == 'monthly') {
      this.subscription_type.monthly.enabled = true;
      this.subscription_type.annual.enabled = false;
      this.plan_selected = this.subscription_type.monthly;
    } else {
      this.subscription_type.monthly.enabled = false;
      this.subscription_type.annual.enabled = true;
      this.plan_selected = this.subscription_type.annual;
    }

    this.plans.forEach((plan) => {
      const title = plan.title.toLowerCase();
      plan.price = this.plan_selected[title];
      plan.price_unit = this.plan_selected['price_unit'];

      const subscriptionType =
        this.currentOrganization.subscriptionType.toLowerCase();
      if (subscriptionType.includes(title)) {
        plan.current = true;
      }
    });
  }

  // upgrade plan
  async onUpgradePlan(isNew: boolean, organization?: Organization) {
    this.modalRef.hide();

    const currentPath = window.location.origin + '/dashboard';
    let hostedPage: any = '';
    this.loaderService.show();
    if (isNew) {
      hostedPage = await this.organizationService
        .askHostedPageForCreateSubscriptionFromChargebee(
          currentPath,
          organization
        )
        .toPromise()
        .catch((error) => {
          this.asideExtenderService.show({
            type: Type.ERROR,
            message: 'Chargebee failed',
            title: error.message,
            position: Position.TOP,
          });
          this.loaderService.hide();
        });
    } else {
      hostedPage = await this.organizationService
        .askHostedPageForUpdateSubscriptionFromChargebee(
          this.planName,
          currentPath
        )
        .toPromise()
        .catch((error) => {
          this.asideExtenderService.show({
            type: Type.ERROR,
            message: 'Chargebee failed',
            title: error.message,
            position: Position.TOP,
          });
          this.loaderService.hide();
        });
    }

    this.loaderService.hide();
    window.location.replace(hostedPage.url);
  }

  onSelectPlan(template: TemplateRef<any>, plan: string) {
    if (this.subscription_type.annual.enabled) {
      this.plan_selected = this.subscription_type.annual;
    } else {
      this.plan_selected = this.subscription_type.monthly;
    }

    this.planName = plan.toLowerCase() + '-' + this.plan_selected.value;

    if (this.planName.includes('pro')) {
      let currentPlan = this.currentOrganization.subscriptionType.toLowerCase();
      if (!currentPlan.includes('free')) {
        this.onUpgradePlan(false);
      } else {
        const validations: any[] = [
          Validators.pattern('[a-za-z0-9][-a-za-z0-9.]*'),
          Validators.required,
        ];
        this.upgradeForm = new FormGroup({
          organizationName: new FormControl('', validations),
          plan: new FormControl(this.planName),
        });

        this.modalRef2 = this.modalService.show(template, {
          class: 'modal-dialog-centered',
        });
      }
    }

    if (this.planName.includes('starter')) {
      const popup = createPopup('uqzOI6DC', {
        autoClose: 5000,
        hideHeaders: true,
        hideFooter: true,
        width: 450,
        height: 800,

        onSubmit: () => {},
      });
      popup.open();
    }

    if (this.planName.includes('enterprise')) {
      const popup = createPopup('k1oyfZJS', {
        autoClose: 5000,
        hideHeaders: true,
        hideFooter: true,
        width: 450,
        height: 800,
        onSubmit: () => {},
      });
      popup.open();
    }
  }

  onCloseDialog(): void {
    this.modalRef.hide();
    this.modalRef2.hide();
  }

  // Create a new organization
  onCloseDialog2(): void {
    this.modalRef2.hide();
  }

  onSubmit() {
    let formData = this.upgradeForm.value;

    let organization = {
      name: formData.organizationName,
      subscriptionType: formData.plan,
      isContacted: false,
    };

    this.loading = true;
    this.organizationService.create(organization).subscribe(
      async (response) => {
        this.modalRef.hide();
        this.modalRef2.hide();
        this.loading = false;
        this.asideExtenderService.show({
          type: Type.SUCCESS,
          title: 'Create Organization',
          message: 'Your organization has been created successfully',
          position: Position.TOP,
        });

        const session = this.shareService.getSession();
        this.shareService.setOrganizationSelected(response, session);

        this.onUpgradePlan(true, response);
      },
      (error) => {
        this.loading = false;
        this.asideExtenderService.show({
          type: Type.ERROR,
          title: 'Create Organization',
          message: error.error,
          position: Position.TOP,
        });
      }
    );
  }
}
